{
  "cms.catalogRow.action.duplicateUnit": "Monista",
  "cms.duplicate.titleMarker": "{title} (kopio)",
  "cms.duplicate.done": "Kopio luotu luonnoksiin.",
  "cms.duplicate.error.titleTaken": "Kopiota ei luotu: nimi \"{title}\" on jo käytössä. Nimeä aiempi kopio uudelleen.",
  "cms.duplicate.error.incompleteUnit": "Tätä riviä ei voi monistaa: se ei ole kokonainen julkaisukokonaisuus.",
  "cms.duplicate.error": "Monistaminen epäonnistui. Yritä uudelleen."
}
